var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canCancelRestBreak
    ? _c("BreaksConfirmation", {
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "data-cy",
                          rawName: "v-data-cy",
                          value: "cancel-scheduled-break-header",
                          expression: "'cancel-scheduled-break-header'",
                        },
                      ],
                    },
                    [_vm._v("\n\t\t\tCancel scheduled break?\n\t\t")]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "bodyIcon",
              fn: function () {
                return [
                  _c("OrigamiIcon", {
                    directives: [
                      {
                        name: "data-cy",
                        rawName: "v-data-cy",
                        value: "block-icon",
                        expression: "'block-icon'",
                      },
                    ],
                    staticClass: "tw-text-origami-blue-400",
                    attrs: { name: "break", width: "32", height: "32" },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "bodyText",
              fn: function () {
                return [
                  _vm.formattedRestBreakTimes
                    ? _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "jest",
                              rawName: "v-jest",
                              value: "cancel-scheduled-break-details",
                              expression: "'cancel-scheduled-break-details'",
                            },
                            {
                              name: "data-cy",
                              rawName: "v-data-cy",
                              value: "cancel-scheduled-break-details",
                              expression: "'cancel-scheduled-break-details'",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n\t\t\tCancel your break for " +
                              _vm._s(_vm.formattedRestBreakTimes.startTime) +
                              " to " +
                              _vm._s(_vm.formattedRestBreakTimes.endTime) +
                              "?\n\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "buttons",
              fn: function () {
                return [
                  _c(
                    "OrigamiButton",
                    {
                      directives: [
                        {
                          name: "jest",
                          rawName: "v-jest",
                          value: "cancel-scheduled-break-modal-ok-button",
                          expression:
                            "'cancel-scheduled-break-modal-ok-button'",
                        },
                        {
                          name: "data-cy",
                          rawName: "v-data-cy",
                          value: "cancel-scheduled-break-modal-ok-button",
                          expression:
                            "'cancel-scheduled-break-modal-ok-button'",
                        },
                      ],
                      staticClass: "tw-w-full tw-justify-center",
                      attrs: {
                        variant: "destructive",
                        "is-loading":
                          _vm.$store.state.BreaksManagementWidget
                            .isRequestLoading,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.cancelScheduledRestBreak.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v("\n\t\t\tYes, cancel break\n\t\t")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3636370706
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }